import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = '[ OPTION CHAIN LOADER ]';

const Actions = {
	setOptionChainLoader: `${MODULE_PREFIX} setOptionChainLoader`,
};

// actions
export const setOptionChainLoader = createAction(
	Actions.setOptionChainLoader,
);

export const getOptionChainLoader = (state = {}, optionChainUniqueId = '') => {
	const optionChainLoader = get(
		state,
		`optionChainLoader.${optionChainUniqueId}`,
		false,
	);
	return optionChainLoader;
};

// selectors
const initialState = {};

// reducer
export default createReducer(initialState, (builder) => {
	builder.addCase(setOptionChainLoader, (state, action) => {
		const { isLoading = false, screenId = '' } = action.payload;
		state[screenId] = isLoading;
	});
});
